export default "<div style=\"width:100%;\">\r\n    <div id=\"{{elemId}}\" class=\"arm-pie-chart\">{{chart}}</div>\r\n</div>";